import LoadStore from "./LoadStore";

export default LoadStore;
